export default "__VITE_ASSET__9122f9f4__"